import styled from 'styled-components';

export const StyledSubHeader = styled.div`
  color: ${(props) => props.theme.newPalette.neutral.N800};
  ${(props) => props.theme.newTypography.textStyleBodySemibold}
  margin-bottom: 10px;
`;

export const StyledSubDescription = styled.div`
  color: ${(props) => props.theme.newPalette.neutral.N600};
  ${(props) => props.theme.newTypography.textStyleBody}
`;

export const StyledSubSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3;
  margin-right: 20px;
`;

export const RightSide = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;
